<template>
    <div
        :class="isMobile ? 'mobile-expansion-panel-container' : ''"
        :style="isMobile ? '' : 'margin-right:-16px; margin-left:-16px;'"
        style="margin-bottom: 1px; margin-top: 1px;"
    >
        <v-expansion-panels
            v-model="panel_state"
            :class="isMobile ? 'mobile-expansion-panel' : ''"
            :popout="!isMobile"
            flat
            style="z-index: auto;"
            :style="
                panel_state !== undefined
                    ? isMobile
                        ? 'background-color: var(--v-white-base); margin-bottom: -10px; padding-bottom: 10px;'
                        : 'background-color: var(--v-g2-base);'
                    : ''
            "
        >
            <v-expansion-panel
                v-for="(item, index) in items"
                :key="'panel' + index"
                :class="[
                    panel_state === index ? 'grey lighten-2' : '',
                    spacedWhenOpen && panel_state === index ? 'my-5' : ''
                ]"
                :style="isMobile ? 'background-color: var(--v-white-base)!important;' : ''"
            >
                <v-expansion-panel-header
                    hide-actions
                    class="py-0"
                    :class="isMobile ? 'px-0' : 'px-2'"
                    :style="dense && panel_state !== index ? 'min-height: 40px;' : ''"
                >
                    <v-row
                        no-gutters
                        align="center"
                        align-content="center"
                        style="flex-wrap: nowrap; white-space: nowrap"
                    >
                        <div v-if="hasHeaderSlot" :class="isMobile ? 'ml-2' : 'ml-5'" style="flex-wrap: nowrap">
                            <v-row no-gutters align="center" align-content="center">
                                <slot name="header" :item="item" />
                            </v-row>
                        </div>
                        <div
                            v-else-if="hasClosedHeaderSlot && panel_state === index"
                            :class="isMobile ? 'ml-2' : 'ml-5'"
                            style="flex-wrap: nowrap;"
                        >
                            <v-row no-gutters align="center" align-content="center">
                                <slot name="open-header" :item="item" />
                            </v-row>
                        </div>
                        <div v-else-if="hasOpenHeaderSlot && panel_state !== index" style="flex-wrap: nowrap">
                            <v-row no-gutters align="center" align-content="center" class="fill-height">
                                <slot name="closed-header" :item="item" />
                            </v-row>
                        </div>
                        <v-spacer />
                        <div v-if="panel_state !== index">
                            <v-row no-gutters justify="end">
                                <slot name="closed-actions" :item="item"></slot>
                            </v-row>
                        </div>
                        <div v-if="panel_state === index" class="mr-2">
                            <v-row no-gutters justify="end">
                                <slot name="open-actions" :item="item"></slot>
                            </v-row>
                        </div>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content :class="panel_state === index ? 'pb-3' : ''">
                    <v-card :flat="isMobile" :class="isMobile ? 'px-0' : ''">
                        <slot :item="item"></slot>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import { ref, computed, watch } from "@vue/composition-api";

export default {
    name: "SuperMagicalExpandingSegment",
    props: {
        items: {
            type: [Array, Map],
            default: () => [1]
        },
        spacedWhenOpen: {
            type: Boolean
        },
        dense: {
            type: Boolean
        },
        flat: {
            type: Boolean
        },
        tableMode: {
            type: Boolean
        },
        openKey: {
            type: String,
            default: ""
        },
        value: {
            type: String,
            default: ""
        },
        isMobile: {
            type: Boolean
        }
    },
    setup(props, ctx) {
        const openVal = computed(() => props.value);
        const panel_state = ref(undefined);
        watch (openVal, val => {
            if (val !== props.openKey) {
                // my key is not the current key, setting my state closed
                panel_state.value = undefined;
            }
        }, { immediate: true });
        watch (panel_state, val => {
            if (val !== undefined) {
                // emit my key is current key and i am now open
                ctx.emit("input", props.openKey);
            }
            if (openVal.value === props.openKey && val === undefined) {
                // emit I am currently open but now closing, setting key undefined, all expansion panels are closed
                ctx.emit("input", undefined);
            }
        }, { immediate: true });

        const hasClosedHeaderSlot = computed(() => {
            return ctx.slots["closed-header"];
        });
        const hasOpenHeaderSlot = computed(() => {
            return ctx.slots["open-header"];
        });
        const hasHeaderSlot = computed(() => {
            return ctx.slots["header"];
        });
        return {
            panel_state,
            hasClosedHeaderSlot,
            hasOpenHeaderSlot,
            hasHeaderSlot
        };
    }
};
</script>
